import { useThunkDispatch } from "@omni/components/redux/dispatcher";
import { update as updateProductDetail } from "@omni/components/redux/modules/value/productDetail/productDetail.module";
import { getProductDetail } from "@omni/components/redux/modules/value/productDetail/productDetail.selectors";
import {
    GetStoreStrategy,
    StorePersistenceStrategy,
    StoreService
} from "@omni/components/services/store.service";
import { useSingleStoreCheck } from "@omni/components/utils/hooks/store/useSingleStoreCheck.hook";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const SingleStoreCheck = () => {
    const dispatch = useThunkDispatch();
    const { storeCode } = useSelector(getProductDetail);
    const singleStoreCode = useSingleStoreCheck();

    useEffect(() => {
        if (singleStoreCode) {
            if (singleStoreCode !== storeCode) {
                dispatch(updateProductDetail({ storeCode: singleStoreCode }));
            }
            if (
                StoreService.getStoreCode(GetStoreStrategy.Session) !==
                singleStoreCode
            ) {
                StoreService.setStoreCode(
                    StorePersistenceStrategy.Session,
                    singleStoreCode
                );
            }
        }
    }, [singleStoreCode, dispatch, storeCode]);

    return null;
};

export { SingleStoreCheck };
